import React from "react";
import "../../css/Popup.css";
 
const Popup = props => {
  return (
    <div className="popup">
      <div className="popup-box">
        <span className="close-icon" title="Close without saving" onClick={props.handleClose}>x</span>
        {props.content}
      </div>
    </div>
  );
};
 
export default Popup;